import { sigmapGreen } from '@/components/layout/configurator/sigmap-green';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sm-status',
  imports: [TranslateModule, CommonModule],
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss',
})
export class StatusComponent {
  @Input() status = '';
  @Input() extra = '';
  primaryColor = sigmapGreen[500];
}
